import { createI18n } from 'vue-i18n';
import langJson from '@support/lang';
import { environmentData } from '@support/utils';
import { useRoute } from 'vue-router';

export default defineNuxtPlugin(nuxtApp => {
  const { query, params } = useRoute();

  // ?后lang优先级更高
  const queryLang = query?.lang as string;
  const queryCountry = query?.country as string;
  const lang = params?.lang as string;
  const country = params?.country as string;
  // 更新语言逻辑
  environmentData.requestLang = queryLang || lang;
  environmentData.requestCountry = queryCountry?.toLowerCase() || country;

  environmentData.lang = lang || queryLang;
  environmentData.country = country || queryCountry?.toLowerCase();

  // 多语言
  const i18n = createI18n({
    fallbackLocale: 'en',
    legacy: false,
    globalInjection: true,
    locale: environmentData.lang,
    messages: langJson
  });
  nuxtApp.vueApp.use(i18n);
});
